// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltips_tooltip__+t-DE"};